import React from "react";
import { useNavigate } from "react-router-dom";

import TwoFactorSetupFlow from "@/features/security/TwoFactorSetupFlow.jsx";

export default function TwoFactorAuthApp() {
  const nav = useNavigate();

  return (
    <TwoFactorSetupFlow
      defaultMethod="auth-app"
      role="patient"
      authAppAvailable
      onExit={() => nav("/settings/patient/login-security/two-factor")}
      onDone={() => nav("/settings/patient/login-security/two-factor")}
    />
  );
}
